import React, { useContext } from 'react';
import { TranslationContext } from '../../contexts/TranslationContext';
import { IPostalAddress } from '../../services/WebApiClient';
import { State } from '../../util/useState2';


export function PostalAddressEditorField(props: {
    propName: keyof IPostalAddress;
    defaultName: string;
    address: State<IPostalAddress>;
    htmlType: "text" | "tel" | "email";
    required?: boolean;
    disabled?: boolean;
}) {

    const tc = useContext(TranslationContext);
    const label = tc.translator(`postal address prop ${props.defaultName}`, props.defaultName);
    const id = `pa_${props.propName}`;

    const required = props.required ?? true;

    function setProp(val: string) {
        props.address.set({
            ...props.address.value,
            [props.propName]: val
        });
    }

    return (
        <div className="form-group row">
            <div className="col-sm-4 col-form-label">
                <label htmlFor={id}>
                    {label}:
                </label>
            </div>
            <div className="col-sm-8">
                <input id={id}
                    type={props.htmlType}
                    className="form-control"
                    required={required}
                    placeholder={label}
                    title={label}
                    disabled={props.disabled}
                    onChange={evt => setProp(evt.target.value)}
                />
            </div>
        </div>
    );
}
